

























































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator'
import { downloadfile, downloadpdf } from '@/api/declare'
import { exportList, exportExpertReview } from '@/api/common'
import {
  gettpoiclist,
  getExpertNum,
  getRandomList,
  addExperts,
  getExpertsList,
  getExpertReview,
  getAddExList,
  uploadSource,
  getFileList,
  deleteUploadFile,
  updataStatus,
  setStatus,
  getReport,
  getAccessorysByTopicId
} from '@/api/laddermanage'
import Pagination from '@/components/Pagination/index.vue'
import moment from 'moment'
@Component({
  name: 'guideManage',
  components: { Pagination }
})
export default class extends Vue {
  [x: string]: any;
  // [x: string]: any;
  mounted() {
    this.getList(this.listQuery)
    this.baseurl = (window as any).downloadurl
    this.apiurl = (window as any).baseurl
    this.listQuery.userid = window.sessionStorage.getItem('id')
    this.listQuery.role = Number(window.sessionStorage.getItem('role'))
  }
  public typeidentifier = 1;
  public currtentpage = 1;
  public total: number = 0;
  public topicrole = '';
  public setstateval = '';
  public shstate = '';
  public selectVal = '';
  // 打印凭证的参数
  public printObj = {
    id: 'maincard', // 打印标签的id
    popTitle: 'Document', // 文件标题
    extraCss: 'https://www.google.com,https://www.google.com',
    extraHead: '<meta http-equiv="Content-Language"content="zh-cn"/>'
  };
  public expertQuery: any = {
    typeidentifier: 1,
    pageNum: 1,
    pageSize: 10,
    param: '',
    randomNum: 0,
    topicIds: []
  };
  // 上传文件的接口
  public fileObj = {};
  // 综合评审请求参数
  public expertcomQuery: any = {
    typeidentifier: 1,
    pageNum: 1,
    pageSize: 10,
    param: '',
    numBer: '',
    randomNum: 0,
    topicIds: []
  };
  public formObj: any = {
    title: '',
    expertVis: false,
    number: '', // 选中的人数
    addExoertVis: false, // 添加评审专家模态框
    searcVal: '', // 添加评审专家查询名称
    expertList: [], // 线上专家数组
    tableData: [], // 添加评审专家数据源
    total: 0,
    currentPage: 1,
    multipleExperts: [], // 添加专家页面复选多个数据
    multipleComExperts: [], // 添加综合专家页面复选多个数据
    comExpertVis: false, // 指定综合评审专家
    addcomExoertVis: false, // 指定专家评审页面
    comTableData: [],
    comExpertList: [], // 线下专家数组
    topicId: '', // 课题id
    radioVal: '',
    leaderIndex: 0,
    comCurrentPage: 1,
    comTotal: 0
  };
  public zjhzForm: any = {
    visible: false,
    maxNum: 0,
    minNum: 0,
    average: 0,
    name: '',
    topicUser: '',
    level: '', // 课题级别
    infoList: []
  };
  // 上传凭证相关参数
  public uploadForm: any = {
    visible: false,
    tableData: [],
    diaFile: false,
    fileList: [],
    topicId: '',
    selectVal: ''
  };
  // 查看已上传的凭证
  public uploadsFile: any = {
    visible: false,
    tableData: [],
    diaFile: false,
    fileList: [],
    topicId: '',
    selectVal: ''
  };
  // 课题综合评审驳回参数
  public refuseopic: any = {
    visible: false,
    value: ''
  };
  // 选择人数下拉框
  public options = [
    {
      value: '1',
      label: '1'
    },
    {
      value: '2',
      label: '2'
    },
    {
      value: '3',
      label: '3'
    },
    {
      value: '4',
      label: '4'
    },
    {
      value: '5',
      label: '5'
    }
  ];
  public usestate = [
    {
      value: 1,
      label: '启用'
    },
    {
      value: 0,
      label: '禁用'
    }
  ];
  public roleoptions = [
    {
      label: '中心选题',
      value: 0
    },
    {
      label: '自主选题',
      value: 1
    },
    {
      label: '委托选题',
      value: 2
    }
  ];
  public stateoptions = [
    // {
    //   label: "待审核",
    //   value: 0,
    // },
    // {
    //   label: "终审通过",
    //   value: 1,
    // },
    // {
    //   label: "已撤回",
    //   value: 2,
    // },
    // {
    //   label: "未提交",
    //   value: 3,
    // },
    // {
    //   label: "预算驳回",
    //   value: 4,
    // },
    // {
    //   label: "驳回",
    //   value: 5,
    // },
    // {
    //   label: "形审通过",
    //   value: 6,
    // },
    // {
    //   label: "形审未通过",
    //   value: 7,
    // },
    // {
    //   label: "专家评审中",
    //   value: 8,
    // },
    // {
    //   label: "专家评审完成",
    //   value: 9,
    // },
    // {
    //   label: "综合评审中",
    //   value: 10,
    // },
    // {
    //   label: "综合评审未通过",
    //   value: 11,
    // },
    // {
    //   label: "综合评审通过",
    //   value: 12,
    // },
    {
      label: '阶段汇报',
      value: 13
    },
    {
      label: '阶段汇报已提交',
      value: 20
    },
    {
      label: '阶段评审中',
      value: 15
    },
    {
      label: '阶段评审完成',
      value: 16
    },
    {
      label: '阶段评审通过',
      value: 22
    },
    {
      label: '阶段评审未通过',
      value: 23
    }
    // {
    //   label: "结题汇报",
    //   value: 14,
    // },
    // {
    //   label: "结题汇报已提交",
    //   value: 21,
    // },
    // {
    //   label: "结题评审中",
    //   value: 17,
    // },
    // {
    //   label: "结题评审完成",
    //   value: 18,
    // },
    // {
    //   label: "已结题",
    //   value: 19,
    // },
  ];
  public tableData = [];
  public name = '';
  public isloading = true;
  public uploadLoading = false;
  public idList: any = []; // 批量修改状态的idlist
  public listQuery: any = {
    level: -1,
    limit: 10,
    name: '',
    num: '',
    page: 1,
    state: -1,
    topictype: -1,
    userid: '',
    role: 0,
    expertRole: '',
    typeidentifier: 1,
    scoreVal: ''
  };
  public uploadRules = {
    selectVal: [
      { required: true, message: '请选择综合审批状态', trigger: 'change' }
    ]
  };
  public refuseRule = {
    value: [
      { required: true, message: '请输入审批不通过原因', trigger: 'blur' }
    ]
  };

  private activeEntrustment = null;
  private activeScoreType = null;
  private entrustment = [
    {
      label: '党政办',
      value: '0'
    },
    {
      label: '人事处',
      value: '1'
    },
    {
      label: '财务处',
      value: '2'
    },
    {
      label: '医师资格考试命题处',
      value: '3'
    },
    {
      label: '考务管理处',
      value: '4'
    },
    {
      label: '专业技术资格考试处',
      value: '5'
    },
    {
      label: '专项考试处',
      value: '6'
    },
    {
      label: '职业技能指导处',
      value: '7'
    },
    {
      label: '考试信息技术处',
      value: '8'
    },
    {
      label: '考试质量研究评价处',
      value: '9'
    },
    {
      label: '对外合作处（科创办）',
      value: '10'
    }
  ];
  private scoreType = [
    {
      label: '=',
      value: 0
    },
    {
      label: '>',
      value: 1
    },
    {
      label: '<',
      value: 2
    },
    {
      label: '≠',
      value: 3
    }
  ];
  private plspVisible = false;
  private changeEntrustment(val) {
    if (val == null) {
      this.listQuery.entrustment = -1
    } else {
      this.listQuery.entrustment = val
    }
    this.getList(this.listQuery)
  }
  private clearEntrustment() {
    this.listQuery.entrustment = -1
  }
  private changeScoreType(val) {
    if (val == null) {
      this.listQuery.scoreType = -1
      this.listQuery.scoreVal = ''
    } else {
      this.listQuery.scoreType = val
    }
    if (this.listQuery.scoreVal !== '') {
      this.getList(this.listQuery)
    }
  }
  private clearScoreType() {
    this.listQuery.scoreType = -1
    this.listQuery.scoreVal = ''
  }
  private changeVal(val) {
    this.getList(this.listQuery)
    if (this.listQuery.scoreType !== -1) {
      this.getList(this.listQuery)
    }
  }

  private flag = 0;
  // 获取状态名字
  private getState(stateIdx) {
    const findItem = this.stateoptions2.find(item => item.value === parseInt(stateIdx))
    if (findItem) {
      return findItem.label
    } else return ''
  }
  // 公共下载逻辑
  private async downloadCommon(url, fileNameStr = '文件') {
    try {
      this.uploadLoading = true
      const response = await fetch(url, {
        method: 'GET'
      })

      const blob = await response.blob()
      const objectUrl = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = objectUrl

      const now = new Date()
      const year = now.getFullYear()
      const month = String(now.getMonth() + 1).padStart(2, '0') // 月份从0开始，需+1并补0
      const day = String(now.getDate()).padStart(2, '0')
      const hours = String(now.getHours()).padStart(2, '0')
      const minutes = String(now.getMinutes()).padStart(2, '0')

      // 从响应头读取后端设置的文件名
      const disposition = response.headers.get('Content-Disposition')
      let fileName = `${year}${month}${day}${hours}${minutes} ${fileNameStr}` // 初始文件名

      if (disposition) {
        // 匹配后端返回的 filename（兼容不同格式）
        const match = disposition.match(/filename="?([^";]+)"?/)
        if (match && match[1]) {
          fileName = decodeURIComponent(match[1])
        }
      }

      a.download = fileName
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      URL.revokeObjectURL(objectUrl) // 释放内存
    } catch (error) {
      this.$message.error('下载文件失败，请检查文件是否存在')
    } finally {
      this.uploadLoading = false
    }
  }
  // 导出列表
  private async exportList() {
    if (this.idList.length <= 0) {
      this.$message.warning('至少选择一条数据')
      return
    }
    const url = `${this.apiurl}/topic/export?typeidentifier=1&topicids=${this.idList.join(',')}`
    await this.downloadCommon(url)
  }
  // 导出列表
  private async exportList2() {
    if (this.idList.length <= 0) {
      this.$message.warning('至少选择一条数据')
      return
    }
    const url = `${this.apiurl}/topic/exportTopicInfoExpert?typeidentifier=1&topicids=${this.idList.join(',')}`
    await this.downloadCommon(url)
  }
  // 批量审批
  private plspClick() {
    if (this.idList.length <= 0) {
      this.$message.warning('至少选择一条数据')
      return
    }
    this.plspVisible = true
  }
  // 评审汇总
  private async downSum() {
    if (this.idList.length <= 0) {
      this.$message.warning('至少选择一条数据')
      return
    }
    const url = `${this.apiurl}/topic/exportExpertReview?typeidentifier=1&topicids=${this.idList.join(',')}`
    await this.downloadCommon(url)
  }

  // 批量值定结题审核专家
  public allToper() {
    if (this.idList.length <= 0) {
      this.$message.warning('至少选择一条数据')
      return
    }

    for (const item of this.tableData as any[]) {
      for (const sonItem of this.idList) {
        if (item.id === sonItem) {
          if (item.state !== '15' && item.state !== '20') {
            this.$message.warning(`所选数据中含有状态不符的数据`)
            return
          }
        }
      }
    }

    this.flag = 0
    this.typeidentifier = 1
    this.formObj.expertVis = true
    this.selectVal = ''
    this.formObj.title = '指定评审专家'
    // this.formObj.topicId = val.id
    this.expertcomQuery.topicIds = []
    this.expertcomQuery.topicIds.push(...this.idList)
    let param: any = {
      type: 1, // 1线上专家 2线下专家
      typeidentifier: 1,
      topicIds: this.idList.join(',')
    }
    getExpertsList(param).then((res) => {
      this.formObj.expertList = res.data
    })
  }

  // 下载报告
  private async downReport() {
    if (this.idList.length <= 0) {
      this.$message.warning('至少选择一条数据')
      return
    }
    const url = `${this.apiurl}/topic/batchDownload?typeidentifier=1&topicids=${this.idList.join(',')}`
    await this.downloadCommon(url)
  }

  // 获取列表
  public async getList(params: any) {
    if (params.scoreType !== -1 && params.scoreVal !== '') {
      params.scoreVal = Number(params.scoreVal)
    }
    // 限制搜索范围
    params['stateList'] = [13, 15, 16, 20, 22, 23]
    await gettpoiclist(params)
      .then((res) => {
        console.log(res)
        if (res.code === 200) {
          this.tableData = res.data.itemBeanList[0]
          this.total = res.data.total
          this.isloading = false
        }
      })
      .catch(() => {
        // this.list = [];
        // this.listLoading = false;
      })
  }
  // 批量设置状态
  public setstate(val) {
    if (this.setstateval === '') return
    if (this.idList.length == 0) {
      this.$message.warning('请先选择课题')
      this.setstateval = ''
      return
    }
    // this.setstateval='';
    let params: any = { idList: this.idList, state: this.setstateval }
    console.log(params)
    setStatus(params)
      .then((res) => {
        if (res.code === 200) {
          (this.$refs.popRef as any) && (this.$refs.popRef as any).doClose()
          this.getList(this.listQuery)
          this.$message.success('状态修改成功')
          this.setstateval = ''
          this.plspVisible = false
        }
      })
      .catch(() => {})
  }
  public cleardata() {
    this.listQuery.state = -1
    this.getList(this.listQuery)
  }
  public changestate(val) {
    if (val == null) {
      this.listQuery.state = -1
    } else {
      this.listQuery.state = val
    }
    this.getList(this.listQuery)
  }
  public prints() {
    let prints: any = document.getElementById('maincard')
    prints.title = '课题专家评审汇总内容'
  }
  public changerole(val) {
    console.log(val === '')
    if (val === '') {
      this.listQuery.topictype = -1
    } else {
      this.listQuery.topictype = val
    }
    console.log(this.listQuery.topictype)
    this.getList(this.listQuery)
  }
  public onSubmit() {
    this.listQuery.page = 1
    this.listQuery.name = this.name
    this.getList(this.listQuery)
  }
  public clearSearch() {
    this.listQuery = {
      level: -1,
      limit: 10,
      name: '',
      num: '',
      page: 1,
      state: -1,
      topictype: -1,
      userid: '',
      role: 0,
      expertRole: ''
    }
    this.name = ''
    this.topicrole = ''
    this.shstate = ''
    this.setstateval = ''
    this.getList(this.listQuery)
  }
  // 查询线上线下专家
  searchUserList() {
    getAddExList(this.expertQuery).then((res) => {
      if (res.code === 200) {
        this.formObj.tableData = res.data.list.records
        this.formObj.total = res.data.total
      }
    })
  }
  public watchitem(params, row) {
    let topicinfo: any = JSON.stringify(row)
    window.sessionStorage.setItem(
      'topicid',
      JSON.stringify({ topicId: params })
    )
    window.sessionStorage.setItem('iswatch', 'false')
    window.sessionStorage.setItem('ishandle', 'true')
    window.sessionStorage.setItem('topicinfo', topicinfo)
    let time = row.createtime.substring(0, 4)
    window.sessionStorage.setItem('time', time)
    if (row.isrefuse == 1) {
      window.sessionStorage.setItem('isrefuse', 'true')
    } else {
      window.sessionStorage.removeItem('isrefuse')
    }
    this.$router.push({ path: '/ladder/ladder', query: { from: '1' } })
  }
  public giveProject(params: any, row: any) {
    let topicinfo: any = JSON.stringify(row)
    window.sessionStorage.setItem('topicid', JSON.stringify(params))
    window.sessionStorage.setItem('iswatch', 'true')
    window.sessionStorage.setItem('topicinfo', topicinfo)
    window.sessionStorage.removeItem('ishandle')
    let time = row.createtime.substring(0, 4)
    window.sessionStorage.setItem('time', time)
    debugger
    // isrefuse=1的时候是预算驳回后重新上传的状态 declare页面显示预算驳回后的表格
    if (row.isrefuse == 1) {
      window.sessionStorage.setItem('isrefuse', 'true')
    } else {
      window.sessionStorage.removeItem('isrefuse')
    }
    this.$router.push({ path: '/delcareProject/delcareProject' })
  }
  public async editItem(params: any, row: any) {
    let topicinfo: any = JSON.stringify(row)
    window.sessionStorage.setItem('topicid', JSON.stringify(params))
    window.sessionStorage.setItem('iswatch', 'true')
    window.sessionStorage.setItem('topicinfo', topicinfo)
    window.sessionStorage.removeItem('ishandle')
    let time = row.createtime.substring(0, 4)
    window.sessionStorage.setItem('time', time)
    // isrefuse=1的时候是预算驳回后重新上传的状态 declare页面显示预算驳回后的表格
    if (row.isrefuse == 1) {
      window.sessionStorage.setItem('isrefuse', 'true')
    } else {
      window.sessionStorage.removeItem('isrefuse')
    }
    this.$router.push({ path: '/declare/declare' })
  }
  downfile(type_, row) {
    // alert(1)
    let typeidentifier = 0
    if (
      (row.state >= 17 && row.state <= 19) ||
      row.state == 14 ||
      row.state == 21
    ) {
      typeidentifier = 1
    }
    let param = {
      topicid: row.id,
      typeidentifier: typeidentifier
    }

    getAccessorysByTopicId(param).then((res) => {
      console.log('Topicladders', res, row.state)
      if (res.code === 200) {
        if (res.data && res.data.length > 0) {
          let _d = res.data[0]
          let href = this.baseurl + '/pdf/' + _d.filepath
          // const savea = document.createElement('a')
          // savea.download = row.fileName
          // savea.href = href
          // savea.click()

          // window.open(href, '_blank');

          this.downloadCommon(href, '阶段报告')
        }
      }
    })
  }
  watchfile(type_, row) {
    let param = {
      id: row.id
    }
    let sbdata: any = {} // 申报对象集合
    let ysdaya: any = {} // 预算对象集合
    downloadpdf(param).then((res) => {
      if (res.code === 200) {
        // state 0未生成 1生成中 2已生成
        let data_ = res.data
        data_.forEach((res) => {
          // res.type=0 完整版pdf  =1预算pdf
          if (res.type === 0) {
            sbdata = res
          } else {
            ysdaya = res
          }
        })
        if (type_ === 0) {
          if (sbdata.state === 0) {
            this.$message.warning('报告暂未生成，请先生成后下载')
          } else if (sbdata.state === 1) {
            this.$message.warning('报告正在生成中,请稍后下载')
          } else {
            var x = new XMLHttpRequest()
            let href = this.baseurl + 'pdf/' + sbdata.url
            x.open('GET', href, true)
            x.responseType = 'blob'
            x.onload = function(e) {
              var url = window.URL.createObjectURL(x.response)
              var a = document.createElement('a')
              a.href = url
              a.target = '_blank'
              // if (row.name == null) {
              //   a.download = "报告";
              // } else {
              //   a.download = row.name + "报告";
              // }
              a.click()
            }
            x.send()
          }
        } else {
          if (ysdaya.state === 0) {
            this.$message.warning('预算表暂未生成，请先生成后下载')
          } else if (ysdaya.state === 1) {
            this.$message.warning('预算表正在生成中,请稍后下载')
          } else {
            let href = this.baseurl + '/pdf/' + ysdaya.url
            let url = window.URL.createObjectURL(href)
            const savea = document.createElement('a')
            savea.download = 'sss'
            if (row.name == null) {
              savea.download = '预算表'
            } else {
              savea.download = row.name + '预算表'
            }
            savea.href = url
            savea.click()
          }
        }
      }
    })
  }
  public handleClose() {
    this.formObj.expertVis = false
  }

  // 分页
  public handleSizeChange(val: number) {
    this.listQuery.limit = val
    this.getList(this.listQuery)
  }
  public handleCurrentChange(val: number) {
    this.listQuery.page = val
    this.getList(this.listQuery)
  }
  public expertSizeChange(val) {
    this.expertQuery.pageSize = val
    this.getExpertList(this.expertQuery)
  }
  public expertCurrentChange(val) {
    this.expertQuery.pageNum = val
    this.getExpertList(this.expertQuery)
  }
  public expertcomSize(val) {
    this.expertcomQuery.pageSize = val
  }
  public expertcomPage(val) {
    this.expertcomQuery.pageNum = val
  }
  // 指定专家单选组长
  public getCurrentRow(val) {
    this.formObj.leaderIndex = val
    this.formObj.comExpertList.forEach((res) => {
      res.isgroupleader = false
    })
    this.formObj.comExpertList[val].isgroupleader = true
  }
  public cellStyle({
    row,
    column,
    rowIndex,
    columnIndex
  }: {
    row: any;
    column: any;
    rowIndex: any;
    columnIndex: any;
  }) {
    return 'text-align:center'
  }

  public rowClass({ row, rowIndex }: { row: any; rowIndex: any }) {
    return 'text-align:center'
  }
  // 指定专家模态框
  public giveExperst(val, typeidentifier) {
    this.typeidentifier = typeidentifier
    this.formObj.expertVis = true
    this.selectVal = ''
    this.formObj.title = '指定评审专家'
    this.formObj.topicId = val.id
    this.expertcomQuery.topicIds = []
    this.expertcomQuery.topicIds.push(val.id)
    let param: any = {
      type: 1, // 1线上专家 2线下专家
      typeidentifier: 1,
      topicIds: this.formObj.topicId
    }
    getExpertsList(param).then((res) => {
      this.formObj.expertList = res.data
    })
  }
  // 指定线下专家
  public giveLeader(val) {
    this.formObj.comExpertVis = true
    this.formObj.title = '指定综合评审专家'
    this.expertcomQuery.numBer = ''
    this.formObj.topicId = val.id
    this.expertcomQuery.topicIds.push(val.id)
    let param: any = {
      type: 2, // 1线上专家 2线下专家
      typeidentifier: 1,
      topicIds: this.formObj.topicId
    }
    getExpertsList(param).then((res) => {
      this.formObj.comExpertList = res.data
      this.formObj.radioVal = true
    })
  }
  // 随机抽取线上专家人数
  choosePerson() {
    let param: any = {
      pageNum: 1,
      pageSize: 10,
      param: '',
      topicIds: []
    }
    param.randomNum = Number(this.selectVal)
    param.topicIds.push(this.formObj.topicId)
    getRandomList(param).then((res) => {
      if (res.code === 200) {
        this.formObj.expertList = this.formObj.expertList.concat(res.data)
        let newObj = {}
        this.formObj.expertList = this.formObj.expertList.reduce(
          (cur, next) => {
            newObj[next.id] ? '' : (newObj[next.id] = true && cur.push(next))
            return cur
          },
          []
        )
      } else if (res.code === 417) {
        this.$message.warning(res.message)
      }
    })
  }
  chooseComPerson() {
    let param: any = {
      pageNum: 1,
      pageSize: 10,
      param: '',
      topicIds: []
    }
    param.randomNum = Number(this.expertcomQuery.numBer)
    param.topicIds.push(this.formObj.topicId)
    getRandomList(param).then((res) => {
      if (res.code === 200) {
        this.formObj.comExpertList = this.formObj.comExpertList.concat(
          res.data
        )
        let newObj = {}
        this.formObj.comExpertList = this.formObj.comExpertList.reduce(
          (cur, next) => {
            newObj[next.id] ? '' : (newObj[next.id] = true && cur.push(next))
            return cur
          },
          []
        )
      } else if (res.code === 417) {
        this.$message.warning(res.message)
      }
    })
  }
  // 添加评审专家
  addPerson() {
    this.flag = 1
    this.formObj.addExoertVis = true
    this.formObj.title = '添加评审专家'
    this.expertQuery.param = ''
    console.log(this.flag)
    console.log(this.idList)
    if (this.flag === 0) { // 批量设置
      this.expertQuery.topicIds = this.idList
    } else if (this.flag === 1) { // 单独设置
      this.expertQuery.topicIds.push(this.formObj.topicId)
    }
    getAddExList(this.expertQuery).then((res) => {
      if (res.code === 200) {
        this.formObj.tableData = res.data.list.records
        this.formObj.total = res.data.total
      }
    })
  }
  // 从指定综合评审专家进入的添加评审专家
  addcomPerson() {
    this.formObj.addcomExoertVis = true
    this.formObj.title = '添加指定综合评审专家'
    this.expertcomQuery.param = ''
    this.expertcomQuery.topicIds.push(this.formObj.topicId)
    getAddExList(this.expertcomQuery).then((res) => {
      if (res.code === 200) {
        this.formObj.comTableData = res.data.list.records
        this.formObj.comTotal = res.data.total
      }
    })
  }
  // 提交线下专家
  submitComExperts() {
    let param: any = []
    let obj: any = {
      expertIds: [],
      typeidentifier: 1,
      topicId: this.formObj.topicId,
      type: 2
    }
    this.formObj.comExpertList.forEach((res) => {
      let expertObj: any = {}
      expertObj.expertId = res.id
      expertObj.isgroupleader = false
      obj.expertIds.push(expertObj)
    })
    obj.expertIds[this.formObj.leaderIndex].isgroupleader = true
    param.push(obj)
    addExperts(param).then((res) => {
      if (res.code === 200) {
        this.$message.success('课题绑定综合评审专家成功')
        this.formObj.expertVis = false
        this.formObj.comExpertVis = false
        this.formObj.addcomExoertVis = false
        this.getList(this.listQuery)
      } else if (res.code === 417) {
        this.$message.warning(res.data)
      }
    })
  }
  addChooseExperts() {
    this.formObj.addExoertVis = false
    this.formObj.expertList = this.formObj.expertList.concat(
      this.formObj.multipleExperts
    )
    console.log('xxx', this.formObj.expertList)
    let newObj = {}
    this.formObj.expertList = this.formObj.expertList.reduce((cur, next) => {
      newObj[next.id] ? '' : (newObj[next.id] = true && cur.push(next))
      return cur
    }, [])
  }
  // 指定线上专家
  submitExperts() {
    console.log(1)
    let param: any = []
    if (this.flag === 0) {
      for (const item of this.idList) {
        let obj: any = {
          expertIds: [],
          topicId: item,
          type: 1,
          typeidentifier: this.typeidentifier
        }
        this.formObj.expertList.forEach((res) => {
          let expertObj: any = {}
          expertObj.expertId = res.id
          expertObj.i0sgroupleader = false
          obj.expertIds.push(expertObj)
        })
        param.push(obj)
      }
    } else {
      let obj: any = {
        expertIds: [],
        topicId: this.formObj.topicId,
        type: 1,
        typeidentifier: this.typeidentifier
      }
      this.formObj.expertList.forEach((res) => {
        let expertObj: any = {}
        expertObj.expertId = res.id
        expertObj.i0sgroupleader = false
        obj.expertIds.push(expertObj)
      })
      param.push(obj)
    }

    addExperts(param).then((res) => {
      if (res.code === 200) {
        this.$message.success('课题绑定综合评审专家成功')
        this.formObj.expertVis = false
        this.formObj.addcomExoertVis = false
        this.formObj.addcomExoertVis = false
        this.getList(this.listQuery)
      } else {
        this.$message.warning(res.message)
      }
    })
  }
  // 提交选择专家
  submitchooseExperts() {
    this.formObj.comExpertList = this.formObj.comExpertList.concat(
      this.formObj.multipleComExperts
    )
    let newObj = {}
    this.formObj.comExpertList = this.formObj.comExpertList.reduce(
      (cur, next) => {
        newObj[next.id] ? '' : (newObj[next.id] = true && cur.push(next))
        return cur
      },
      []
    )
    this.formObj.addcomExoertVis = false
    this.formObj.title = '指定综合评审专家'
  }
  // 综合审批通过
  agreeTopic() {
    let param = {
      dismiss: '',
      id: this.uploadForm.topicId,
      state: 12
    }
    updataStatus(param).then((res) => {
      if (res.code === 200) {
        this.uploadForm.visible = false
        this.getList(this.listQuery)
      }
    })
  }
  // 提交内容
  submitRefuse() {
    (this.$refs.refuseRule as any).validate((valid) => {
      if (valid) {
        let param = {
          dismiss: this.refuseopic.value,
          id: this.uploadForm.topicId,
          state: 11
        }
        updataStatus(param).then((res) => {
          if (res.code === 200) {
            this.uploadForm.visible = false
            this.refuseopic.visible = false
            this.$message.success('课题综合评审评审未通过')
          }
        })
      }
    })
  }
  // 综合审批通过
  refuseTopic() {
    this.refuseopic.visible = true
  }
  expertSize(val) {
    this.expertQuery.limit = val
    this.addPerson()
  }
  expertPage(val) {
    this.expertQuery.page = val
    this.addPerson()
  }

  // 列表复选框
  handleSelectionChangeList(val) {
    this.idList = []
    val.forEach((res: any) => {
      this.idList.push(res.id)
    })
  }
  // 添加专家复选框
  handleSelectionChange(val) {
    this.formObj.multipleExperts = val
  }
  handleSelectionComChange(val) {
    this.formObj.multipleComExperts = val
  }
  closeExperts() {
    this.formObj.addExoertVis = false
    this.formObj.addcomExoertVis = false
  }
  // 关闭指定线下专家模态框
  closeComExpert() {
    this.formObj.comExpertVis = false
    this.zjhzForm.visible = false
  }
  // 删除指定专家
  removeChoose(index) {
    this.formObj.expertList.splice(index, 1)
    this.searcVal = String(this.formObj.expertList.length)
  }
  removeChooseCom(index) {
    this.formObj.comExpertList.splice(index, 1)
    this.expertcomQuery.numBer = String(this.formObj.expertList.length)
  }
  // 查询专家评审汇总
  getExpertScore(val, typeidentifier) {
    this.zjhzForm.visible = true
    this.zjhzForm.infoList = []
    let param = {
      topicId: val.id,
      typeidentifier: typeidentifier
    }
    getExpertReview(param).then((res) => {
      if (res.code === 200) {
        this.zjhzForm.maxNum = res.data.maxScore
        this.zjhzForm.minNum = res.data.minScore
        this.zjhzForm.average = res.data.average
        this.zjhzForm.name = val.name
        this.zjhzForm.topicUser = val.headname
        res.data.infoList.forEach((res: any) => {
          if (res.score !== null && res.idea !== null) {
            this.zjhzForm.infoList.push(res)
          }
        })
      }
    })
  }
  claseZjhz() {
    this.uploadForm.visible = false
  }
  closebhZjhz() {
    this.refuseopic.visible = false
  }
  // 上传文件
  uploadPzfile(val) {
    this.uploadForm.visible = true
    this.uploadForm.topicId = val
    this.getFileList()
  }
  watchUploadFile(val) {
    this.uploadsFile.visible = true
    this.uploadsFile.topicId = val
    let param = {
      id: val
    }
    getFileList(param).then((res) => {
      if (res.code === 200) {
        this.uploadsFile.tableData = res.data
      }
    })
  }
  //
  claseHandleFile() {
    this.uploadsFile.visible = false
  }
  // 查询专家上传的课题文件
  getFileList() {
    let param = {
      id: this.uploadForm.topicId
    }
    getFileList(param).then((res) => {
      if (res.code === 200) {
        this.formObj.tableData = res.data
      }
    })
  }
  // 上传文件文件列显示icon图标
  renderHeader(h, { column }) {
    // h即为cerateElement的简写，具体可看vue官方文档
    return h('div', [
      h('span', column.label),
      h('i', {
        class: 'el-icon-folder',
        style: 'margin-left:5px;font-size:15px'
      })
    ])
  }
  // 按名称查询专家
  chooseExpert() {
    getAddExList(this.expertcomQuery).then((res) => {
      if (res.code === 200) {
        this.formObj.comTableData = res.data.list.records
        this.formObj.comTotal = res.data.total
      }
    })
  }
  // 打开上传文件的页面
  openFileDia() {
    this.uploadForm.diaFile = true
    this.uploadForm.fileList = []
  }
  // 上传文件接口
  handleCloseFile() {
    this.uploadForm.diaFile = false
  }
  fileBeforeRemove(file: any, fileList: any) {
    this.uploadForm.fileList = fileList
  }
  topicfilechange(file) {
    this.uploadForm.fileList.push(file)
  }
  // 上传凭证
  uploadFile() {
    if (this.uploadForm.fileList.length === 0) {
      this.$message.warning('当前未选择数据')
    } else {
      let formData: any = new FormData()
      this.uploadForm.fileList.forEach((res: any) => {
        formData.append('files', res.raw)
      })
      formData.append('topicId', this.uploadForm.topicId)
      formData.append('userId', window.sessionStorage.getItem('id'))
      uploadSource(formData).then((res) => {
        if (res.code === 200) {
          this.$message.success('专家表上传成功')
          this.uploadForm.diaFile = false
          this.getFileList()
        } else if (res.code === 417) {
          this.$message.warning(res.message)
        }
      })
    }
  }
  // 删除上传的凭证
  removeFile(val) {
    let param = {
      id: val
    }
    this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      deleteUploadFile(param).then((res) => {
        if (res.code === 200) {
          this.$message.success('文件删除成功')
          this.getFileList()
        }
      })
    })
  }
  // 下载上传的凭证
  downLoadFile(val) {
    var x = new XMLHttpRequest()
    // sbdata.url字符串前面的是完整版申报pdf 后面的是论证活页的pdf
    // let href = this.baseurl + '/evaluation/' + val.filename
    let href = this.baseurl + '/evaluation/' + val.filename
    x.open('GET', href, true)
    x.responseType = 'blob'
    x.onload = function(e) {
      var url = window.URL.createObjectURL(x.response)
      var a = document.createElement('a')
      a.href = url
      a.download = val.filename
      a.click()
    }
    x.send()
  }
}
